import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-sjtj",
  "use": "icon-menu-sjtj-usage",
  "viewBox": "0 0 200 199.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 199.8\" id=\"icon-menu-sjtj\">\r\n<path d=\"M107.3,97.3H200c0-52.2-41.1-94.7-92.7-97.3L107.3,97.3z\" />\r\n<path d=\"M97.6,111.9c-2.7,0-4.9-2.2-4.9-4.9V4.9C41.1,7.4,0,49.9,0,102.2c0,53.9,43.7,97.5,97.6,97.5c50.6,0,92.2-38.5,97.1-87.8\r\n\tL97.6,111.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol